import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { leaveOpenClub } from '../utils/openClub';
import './PreviewBanner.css';

// Shown on every screen while a super admin has a club open
export default function OpenClubBanner() {
  const { user } = useAuth();
  const acting = user?.actingAs;
  // When the hour is up, go back to the portal rather than meet errors
  useEffect(() => {
    if (!acting) return undefined;
    const t = setTimeout(() => leaveOpenClub(), Math.max(0, new Date(acting.expiresAt) - Date.now()));
    return () => clearTimeout(t);
  }, [acting]);
  if (!acting) return null;
  const until = new Date(acting.expiresAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return (
    <div className="preview-banner preview-banner--open-club" role="status">
      <span>
        You're in <strong>{acting.clubName}</strong> as super admin, until {until}. What you change is logged under your name.
      </span>
      <button type="button" className="preview-banner__exit" onClick={() => leaveOpenClub()}>
        Leave
      </button>
    </div>
  );
}
